import { useEffect, useState } from "react";
import { formatStripeCode } from "@utils/format";
import { SubscriptionStatus, digitalSubscriptions, useUserProfile } from "@providers/profile";
import AccountTransfer from "../account-transfer";
import { AccountFormProps, FormItemType } from "./AccountForm.model";
import { Alert, InlineUpdateButton } from "@components/account/Account.styled";

const AccountForm = ({ isDigital, state, dispatchState, subscription }: AccountFormProps) => {
  const [accountStatus, setAccountStatus] = useState<SubscriptionStatus>();
  const {
    profileState: { profile },
  } = useUserProfile();

  const onEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: FormItemType) => {
    e.preventDefault();
    dispatchState({ ...state, editing: item });
  };

  useEffect(() => {
    setAccountStatus(
      subscription?.subscription_status
        ? subscription.subscription_status
        : SubscriptionStatus.Inactive
    );
  }, [subscription]);

  return (
    <div>
      {state.updated && <Alert>{state.updated}</Alert>}
      <dl>
        <dt>
          Email Address{" "}
          <InlineUpdateButton onClick={(e) => onEdit(e, "email")}>(change)</InlineUpdateButton>
        </dt>
        <dd>{profile?.email || "--"}</dd>
        <dt>
          Password{" "}
          <InlineUpdateButton onClick={(e) => onEdit(e, "password")}>(change)</InlineUpdateButton>
        </dt>
        <dd>● ● ● ● ● ● ● ●</dd>
        <dt>Account status</dt>
        <dd>{formatStripeCode(accountStatus) || "--"}</dd>
        <AccountTransfer />
      </dl>
    </div>
  );
};

export default AccountForm;
